//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { IScheduledPost } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import PostableId from '@models/PostableId';
import { TikTokSummaryPerformanceOption } from '@tiktok/components/summary/tiktokSummaryConstants';
import { Normalized } from '@utils/normalize';

export type NormalizedScheduledPosts = Normalized<IScheduledPost, PostableId>;

export interface ITikTokSummaryState {
  currentGraphMetric: TikTokSummaryPerformanceOption;
  upcomingScheduledPosts: NormalizedScheduledPosts;

  flags: {
    isDeletingUpcomingScheduledPost: boolean;
    isFetchingUpcomingScheduledPosts: boolean;
  };
  errors: {
    deleteUpcomingScheduledPostError: string | undefined;
    fetchUpcomingScheduledPostsError: string | undefined;
  };
  modals: {
    selectedPostIdForDeleteUpcomingScheduledPostModal: PostableId | undefined;
    isDeleteUpcomingScheduledPostModalOpen: boolean;
  };
}

export const UPCOMING_SCHEDULED_POSTS_COUNT = 4;
